import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/additionalInformation/${COMMON_QUERY_PARAMS.ID}/file`;

export async function setClaimAdditionalInformationWithFilesCommand({
  claimId,
  additionalInformationId,
  file,
}: {
  claimId: string;
  additionalInformationId: string;
  file: File;
}): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const body = new FormData();

    body.append('fileBinary', file);

    return await apiCall<BaseBackResponse>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId).replace(
        COMMON_QUERY_PARAMS.ID,
        additionalInformationId,
      ),
      {
        method: SUPPORTED_METHODS.POST,
        body,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
